// L'ordonnanceur (méthode J adaptative) : réglages, préréglages, réglage par l'IA, et construirePlanning(),
// le calcul pur que triggerAutoPlan enveloppe de ses dialogues et de l'enregistrement.
// --- CONFIGURATIONS SAUVEGARDÉES DE L'AUTO-PLANIFICATEUR ---
// Préréglages intégrés de l'Auto-Planifier : ordre chronologique des matières (les matières non citées suivent, par ordre alphabétique)
window.BUILTIN_AUTOPLAN_PRESETS = [
    { id: 'builtin_ordre_matieres', name: 'Ordre des matières : Autre → Neuro → Hémato → Gynéco → Pédiatrie → …', order: ['Autre', 'Neurologie', 'Hématologie', 'Gynéco-Obstétrique', 'Pédiatrie', 'Infectiologie', 'Santé publique', 'Pneumologie', 'Cardiologie', 'Endocrinologie', 'Dermatologie', 'Rhumatologie', 'Gastro-entérologie', 'Néphrologie', 'Psychiatrie', 'Gériatrie', 'Pharmacologie', 'Réa-Urgences', 'ORL', 'Orthopédie-Trauma.', 'Génétique', 'Ophtalmologie', 'Immunologie', 'Urologie', 'MPR', 'Chirurgie dig.'] }
];
window.builtinPresetConfig = function(p) {
    var all = window.allSpecialties || [], ordered = [];
    p.order.forEach(function(name) {
        var norm = window.normalizeSpecialty(name);
        var hit = all.find(function(sp) { return sp === norm || sp.toLowerCase() === name.toLowerCase(); });
        if (hit && ordered.indexOf(hit) === -1) ordered.push(hit);
    });
    all.forEach(function(sp) { if (ordered.indexOf(sp) === -1) ordered.push(sp); });
    return { sortStrategy: 'specialty', selectedSpecs: [].concat(all), orderedSpecialties: ordered };
};
window.loadAutoPlanPresetsLocal = function() {
    var raw = localStorage.getItem('edn_autoplan_presets'), local = [];
    try { local = raw ? JSON.parse(raw) : []; } catch(e) { local = []; }
    var builtin = window.BUILTIN_AUTOPLAN_PRESETS.map(function(p) { return { id: p.id, name: p.name, builtin: true, config: window.builtinPresetConfig(p) }; });
    return builtin.concat(local.filter(function(p) { return !p.builtin; }));
};
window.saveAutoPlanPresetsLocal = function(list) {
    localStorage.setItem('edn_autoplan_presets', JSON.stringify(list.filter(function(p) { return !p.builtin; })));
};

window.actions.saveAutoPlanPreset = function() {
    var name = prompt("Nom de cette configuration :", "");
    if (!name || !name.trim()) return;
    var s = window.state;
    var presets = window.loadAutoPlanPresetsLocal();
    var id = 'preset_' + Date.now().toString(36);
    presets.push({
        id: id,
        name: name.trim(),
        config: {
            sortStrategy: s.sortStrategy,
            appendMode: s.appendMode,
            maxJLimit: s.maxJLimit,
            isLoopMode: s.isLoopMode,
            itemsPerDay: s.itemsPerDay,
            useSubPartsInAutoPlan: s.useSubPartsInAutoPlan,
            blocDepuisJ: s.blocDepuisJ || 0,
            chargeTotaleParJour: s.chargeTotaleParJour || 0,
            plafondJ0ParJour: s.plafondJ0ParJour || 0,
            plafondRevisionsParJour: s.plafondRevisionsParJour || 0,
            pasJ0: s.pasJ0 === 2 ? 2 : 1,
            spacingMode: s.spacingMode || 'score',
            spacingCommun: s.spacingCommun || '',
            doublePediatrie: s.doublePediatrie,
            selectedSpecs: [].concat(s.selectedSpecs),
            orderedSpecialties: [].concat(s.orderedSpecialties),
            deuxiemeLot: !!s.deuxiemeLot,
            doublePediatrie2: !!s.doublePediatrie2,
            selectedSpecs2: [].concat(s.selectedSpecs2 || []),
            orderedSpecialties2: [].concat((s.orderedSpecialties2 || []).length ? s.orderedSpecialties2 : window.allSpecialties),
            configStartDate2: s.configStartDate2 || ''
        }
    });
    window.saveAutoPlanPresetsLocal(presets);
    window.state.selectedAutoPlanPresetId = id;
    window.renderModal();
};

window.actions.applyAutoPlanPreset = function(id) {
    window.state.selectedAutoPlanPresetId = id || null;
    if (!id) { window.renderModal(); return; }
    var preset = window.loadAutoPlanPresetsLocal().find(function(p){ return p.id === id; });
    if (!preset) return;
    Object.assign(window.state, preset.config);
    window.renderModal();
};

window.actions.deleteAutoPlanPreset = function() {
    var id = window.state.selectedAutoPlanPresetId;
    if (!id) return;
    if (id.indexOf('builtin_') === 0) { alert("Ce préréglage est intégré à l'application, il ne peut pas être supprimé."); return; }
    if (!confirm("Supprimer cette configuration sauvegardée ?")) return;
    window.saveAutoPlanPresetsLocal(window.loadAutoPlanPresetsLocal().filter(function(p){ return p.id !== id; }));
    window.state.selectedAutoPlanPresetId = null;
    window.renderModal();
};

// --- AUTO PLANNER SETTINGS ---
window.actions.toggleSpecCheck2 = function(spec) {
    var s = window.state; s.selectedSpecs2 = s.selectedSpecs2 || [];
    if (s.selectedSpecs2.includes(spec)) s.selectedSpecs2 = s.selectedSpecs2.filter(function(x) { return x !== spec; }); else s.selectedSpecs2.push(spec);
    window.renderModal();
};
window.actions.toggleSpecCheck = function(spec) {
    var s = window.state.selectedSpecs;
    if(s.includes(spec)) { window.state.selectedSpecs = s.filter(function(x){return x!==spec;}); }
    else { s.push(spec); }
    window.renderModal();
};
// Ordre de priorité des matières : lot 1 (orderedSpecialties / selectedSpecs) ou lot 2 (orderedSpecialties2 /
// selectedSpecs2), même mécanique. Les matières non cochées gardent leur place, seules les cochées se réordonnent.
window.ordreCles = function(lot) { return lot === 2 ? { ordre: 'orderedSpecialties2', sel: 'selectedSpecs2' } : { ordre: 'orderedSpecialties', sel: 'selectedSpecs' }; };
window.ordreVisible = function(lot) {
    var s = window.state, k = window.ordreCles(lot);
    if (!(s[k.ordre] || []).length) s[k.ordre] = [].concat(window.allSpecialties);
    return s[k.ordre].filter(function(x) { return (s[k.sel] || []).includes(x); });
};
window.actions.moveSpecToPosition = function(spec, newPosRaw, lot) {
    var s = window.state, k = window.ordreCles(lot);
    var visible = window.ordreVisible(lot);
    var total = visible.length;
    var newPos = parseInt(newPosRaw, 10);
    if (isNaN(newPos)) { window.renderModal(); return; }
    newPos = Math.max(1, Math.min(total, newPos));
    var curIdx = visible.indexOf(spec);
    if (curIdx === -1) return;
    visible.splice(curIdx, 1);
    visible.splice(newPos - 1, 0, spec);
    var vi = 0;
    s[k.ordre] = s[k.ordre].map(function(item) {
        return (s[k.sel] || []).includes(item) ? visible[vi++] : item;
    });
    window.renderModal();
};
window.actions.moveSpecUp = function(spec, lot) {
    var visible = window.ordreVisible(lot);
    var idx = visible.indexOf(spec);
    if (idx > 0) window.actions.moveSpecToPosition(spec, idx, lot);
};
window.actions.moveSpecDown = function(spec, lot) {
    var visible = window.ordreVisible(lot);
    var idx = visible.indexOf(spec);
    if (idx !== -1 && idx < visible.length - 1) window.actions.moveSpecToPosition(spec, idx + 2, lot);
};
window.actions.selectAllSpecs = function() { window.state.selectedSpecs = [].concat(window.allSpecialties); window.renderModal(); };
window.actions.deselectAllSpecs = function() { window.state.selectedSpecs = []; window.renderModal(); };

// L'IA (Opus) lit les besoins écrits par l'étudiant et règle l'ordonnanceur : elle ne fabrique pas les tâches, elle
// choisit les réglages (charge, plafonds, rythme des J, J cible des partiels, matières et leur ordre, date de départ),
// l'étudiant relit dans la fenêtre puis lance. Explication et avertissements affichés dans la carte.
window.actions.planningIA = function() {
    var s = window.state, besoins = (s.planningBesoins || '').trim();
    if (!besoins) { alert("Décris d'abord tes besoins dans le champ de texte."); return; }
    if (s.planningIAEnCours) return;
    s.planningIAEnCours = true; s.planningIA = null; window.renderModal();
    var compte = {}; window.ednsItems.forEach(function(i) { compte[i.matiere] = (compte[i.matiere] || 0) + 1; });
    var payload = {
        action: 'ai_planning_config', besoins: besoins.slice(0, 4000), aujourdhui: window.todayStr(),
        matieres: window.allSpecialties.map(function(m) { return { nom: m, items: compte[m] || 0 }; }),
        partiels: window.activeExams().map(function(e) { return { id: e.id, nom: e.name || 'Partiel', date: e.date, matieres: e.specs || [], jCible: e.jCible || 0, marge: e.marge == null ? 30 : e.marge }; }),
        nbItemsScindes: Object.keys(s.subParts || {}).filter(function(k) { return (s.subParts[k] || []).length > 1; }).length,
        nbTachesEnCours: s.tasks.filter(function(t) { return t.status === 'pending'; }).length,
        reglages: { sortStrategy: s.sortStrategy, appendMode: !!s.appendMode, maxJLimit: s.maxJLimit, isLoopMode: !!s.isLoopMode, itemsPerDay: s.itemsPerDay, chargeTotaleParJour: s.chargeTotaleParJour || 0, plafondJ0ParJour: s.plafondJ0ParJour || 0, plafondRevisionsParJour: s.plafondRevisionsParJour || 0, spacingMode: s.spacingMode || 'score', spacingCommun: s.spacingCommun || '', pasJ0: s.pasJ0 === 2 ? 2 : 1, blocDepuisJ: s.blocDepuisJ || 0, useSubPartsInAutoPlan: !!s.useSubPartsInAutoPlan, doublePediatrie: !!s.doublePediatrie, configStartDate: s.configStartDate, selectedSpecs: s.selectedSpecs, orderedSpecialties: s.orderedSpecialties }
    };
    window.podcastApi(payload).then(function(res) {
        s.planningIAEnCours = false;
        if (!res || !res.success) { s.planningIA = { erreur: (res && res.message) || 'Réponse serveur non valide' }; window.renderModal(); return; }
        window.appliquerReglagesIA(res.reglages || {}, res.partiels || []);
        s.planningIA = { explication: res.explication || '', avertissements: res.avertissements || [], modele: res.model || '' };
        window.renderModal();
    }).catch(function(e) { s.planningIAEnCours = false; s.planningIA = { erreur: e.message || 'Serveur injoignable' }; window.renderModal(); });
};
// Les réglages rendus par l'IA sont vérifiés un à un avant d'entrer dans l'état : bornes, listes fermées, matières
// connues. Ce qui n'est pas donné ou pas valable reste tel quel.
window.appliquerReglagesIA = function(r, partiels) {
    var s = window.state, entier = function(v, min, max) { var n = parseInt(v, 10); return (isNaN(n) || n < min || n > max) ? null : n; };
    var n;
    if ((n = entier(r.itemsPerDay, 1, 15)) !== null) s.itemsPerDay = n;
    if ((n = entier(r.chargeTotaleParJour, 0, 60)) !== null) s.chargeTotaleParJour = n;
    if ((n = entier(r.plafondJ0ParJour, 0, 60)) !== null) s.plafondJ0ParJour = n;
    if ((n = entier(r.plafondRevisionsParJour, 0, 60)) !== null) s.plafondRevisionsParJour = n;
    if ((n = entier(r.maxJLimit, 7, 365)) !== null) s.maxJLimit = n;
    if ((n = entier(r.blocDepuisJ, 0, 365)) !== null) s.blocDepuisJ = n;
    if (r.pasJ0 === 1 || r.pasJ0 === 2) s.pasJ0 = r.pasJ0;
    if (r.spacingMode === 'score' || r.spacingMode === 'commun') s.spacingMode = r.spacingMode;
    if (typeof r.spacingCommun === 'string' && window.parseJListe(r.spacingCommun).length) s.spacingCommun = window.parseJListe(r.spacingCommun).join(', ');
    if (typeof r.useSubPartsInAutoPlan === 'boolean') s.useSubPartsInAutoPlan = r.useSubPartsInAutoPlan;
    if (typeof r.doublePediatrie === 'boolean') s.doublePediatrie = r.doublePediatrie;
    if (typeof r.isLoopMode === 'boolean') s.isLoopMode = r.isLoopMode;
    if (typeof r.appendMode === 'boolean') s.appendMode = r.appendMode;
    if (r.sortStrategy === 'score' || r.sortStrategy === 'specialty') s.sortStrategy = r.sortStrategy;
    if (/^\d{4}-\d{2}-\d{2}$/.test(r.configStartDate || '') && r.configStartDate >= window.todayStr()) s.configStartDate = r.configStartDate;
    var connues = window.allSpecialties;
    if (Array.isArray(r.selectedSpecs)) { var sel = r.selectedSpecs.filter(function(m) { return connues.indexOf(m) !== -1; }); if (sel.length) s.selectedSpecs = sel; }
    if (Array.isArray(r.orderedSpecialties)) { var ord = r.orderedSpecialties.filter(function(m, i, a) { return connues.indexOf(m) !== -1 && a.indexOf(m) === i; }); if (ord.length) s.orderedSpecialties = ord.concat(connues.filter(function(m) { return ord.indexOf(m) === -1; })); }
    if (Array.isArray(r.orderedSpecialties2)) { var ord2 = r.orderedSpecialties2.filter(function(m, i, a) { return connues.indexOf(m) !== -1 && a.indexOf(m) === i; }); if (ord2.length) s.orderedSpecialties2 = ord2.concat(connues.filter(function(m) { return ord2.indexOf(m) === -1; })); }
    (partiels || []).forEach(function(p) {
        var e = s.exams.find(function(x) { return x.id === p.id; }); if (!e) return;
        if ((n = entier(p.jCible, 0, 365)) !== null) e.jCible = n;
        if ((n = entier(p.marge, 0, 365)) !== null) e.marge = n;
    });
    if (partiels && partiels.length) window.saveExams();
};
// Le calcul, sans dialogue ni enregistrement : `c` = les réglages (la forme de window.state), `contexte` =
// { items: le catalogue, now: l'horloge } — injectés pour que le même calcul soit rejouable dans les tests.
export function construirePlanning(c, contexte) {
    var nT = c.appendMode ? [].concat(c.tasks) : [];
    // Plafond de séances par jour, J0 ET révisions comptés : un J0 n'est posé un jour que si ce jour a encore de
    // la place (les révisions des items déjà posés y comptent) ; un lissage final au même plafond règle le reste.
    var cap = Math.max(0, parseInt(c.chargeTotaleParJour, 10) || 0), capJ0 = Math.max(0, parseInt(c.plafondJ0ParJour, 10) || 0), capRev = Math.max(0, parseInt(c.plafondRevisionsParJour, 10) || 0);
    var parJour = {}, j0Jour = {}, pas = c.pasJ0 === 2 ? 2 : 1;
    var compter = function(t) { parJour[t.date] = (parJour[t.date] || 0) + 1; if (t.type === 'J0') j0Jour[t.date] = (j0Jour[t.date] || 0) + 1; };
    nT.forEach(function(t) { if (t.status === 'pending') compter(t); });
    var pousser = function(t) { nT.push(t); compter(t); };
    // un jour est plein pour un nouveau J0 si le total, le plafond J0 ou le plafond révisions y est atteint
    var jourPlein = function(d) { var tot = parJour[d] || 0, j0 = j0Jour[d] || 0; return (cap && tot >= cap) || (capJ0 && j0 >= capJ0) || (capRev && (tot - j0) >= capRev); };
    var enRetard = [];

    // Un lot = des matières + une date de départ. Deux lots peuvent être posés d'un coup (deuxième planning), les
    // compteurs de charge (parJour, j0Jour) étant partagés : le second respecte les plafonds avec le premier.
    var lot = function(specs, dateDepart, num) {
        var filtered = contexte.items.filter(function(i) {
            if(specs.includes(i.matiere)) return true;
            return i.collegesSecondaires.some(function(x){ return specs.includes(x); });
        });

        // Un item déjà dans le planning (mode « ajouter ») ou déjà posé par le premier lot n'est pas repris : un item
        // dont une matière est dans les deux lots va au premier.
        // Le numéro d'item se lit comme partout ailleurs : baseItemId d'abord, et à défaut itemId DÉBARRASSÉ de son
        // suffixe de sous-partie. Sans ce nettoyage, un planning dont les sous-parties n'ont pas de baseItemId — un
        // export d'une version ancienne, réimporté — n'était reconnu par aucun item, et « ajouter à la suite »
        // reposait l'intégralité du programme une seconde fois.
        var planned = new Set(nT.map(function(t){ return String(t.baseItemId || t.itemId).replace(/_p\d+.*$/, ''); }));
        filtered = filtered.filter(function(i){ return !planned.has(String(i.id)); });

        // Contraintes des partiels (« être à J30 le jour du partiel ») : les items concernés passent en tête, la plus
        // proche échéance de J0 d'abord ; ensuite l'ordre habituel.
        var echeances = {}; filtered.forEach(function(it) { echeances[it.id] = window.echeanceJ0(it, dateDepart); });
        // Chaque lot a son ordre de priorité des matières (le deuxième retombe sur celui du premier s'il n'en a pas).
        var ordre = (num === 1 && (c.orderedSpecialties2 || []).length) ? c.orderedSpecialties2 : c.orderedSpecialties;
        filtered.sort(function(a, b) {
            var eA = echeances[a.id], eB = echeances[b.id];
            if (!!eA !== !!eB) return eA ? -1 : 1;
            if (eA && eB && eA !== eB) return eA.localeCompare(eB);
            var getIdx = function(it) {
                var bi = ordre.indexOf(it.matiere);
                if(bi === -1) bi = 999;
                it.collegesSecondaires.forEach(function(sc) {
                    var px = ordre.indexOf(sc);
                    if(px !== -1 && bi > px) bi = px;
                });
                return bi;
            };
            var iA = getIdx(a); var iB = getIdx(b);
            if(c.sortStrategy === 'specialty') {
                if(iA !== iB) return iA - iB;
                if(b.score !== a.score) return b.score - a.score;
                return a.titre.localeCompare(b.titre);
            } else {
                if(b.score !== a.score) return b.score - a.score;
                if(iA !== iB) return iA - iB;
                return a.titre.localeCompare(b.titre);
            }
        });

        var cD = window.parseDateLocal(dateDepart);
        var plT = 0;
        filtered.forEach(function(it, index) {
            if(plT >= c.itemsPerDay) { cD.setDate(cD.getDate()+pas); plT = 0; }
            if (cap || capJ0 || capRev) { var garde = 3650; while (garde-- > 0 && jourPlein(window.toYYYYMMDD(cD))) { cD.setDate(cD.getDate()+pas); plT = 0; } }
            var stD = new Date(cD);
            if (echeances[it.id] && window.toYYYYMMDD(stD) > echeances[it.id]) enRetard.push(it);
            var rule = window.regleEspacement(it.score);
            var ints = rule.filter(function(day){ return c.maxJLimit >= day; });
            
            if(c.isLoopMode && ints.length > 0) {
                var lst = ints[ints.length-1];
                var step = Math.max(lst, 14);
                ints.push(lst+step, lst+step*2, lst+step*3, lst+step*4);
            }

            var isPed = (num === 1 ? c.doublePediatrie2 : c.doublePediatrie) && it.matiere !== 'Pédiatrie' && it.collegesSecondaires.indexOf('Pédiatrie') !== -1;
            var parts = (c.useSubPartsInAutoPlan && c.subParts[it.id]) ? c.subParts[it.id] : [null];
            // Révisions tardives en un seul bloc : à partir de blocDepuisJ, un item scindé n'est plus revu sous-partie
            // par sous-partie mais d'un coup, une tâche pour l'item entier, datée depuis le J0 de sa dernière sous-partie.
            var blocDepuis = (parts.length > 1 && c.blocDepuisJ > 0) ? c.blocDepuisJ : Infinity;

            parts.forEach(function(partName, pIdx) {
                var pDate = new Date(stD);
                pDate.setDate(pDate.getDate() + pIdx * pas); // sous-parties espacées du même pas, pour garder la parité
                
                var pId = partName ? (it.id + "_p" + contexte.now() + pIdx) : it.id;
                var pTitre = partName ? (it.titre + " [" + partName + "]") : it.titre;

                pousser({ id: pId+"_J0_"+contexte.now()+"_"+num+"_"+index+"_"+pIdx, itemId: pId, baseItemId: it.id, titre: pTitre, matiere: it.matiere, score: it.score, type: 'J0', date: window.toYYYYMMDD(pDate), status: 'pending', isDouble: false });
                
                if(isPed && pIdx === 0) {
                    pousser({ id: it.id+"_J0_bis_"+contexte.now()+"_"+num+"_"+index, itemId: it.id, baseItemId: it.id, titre: it.titre, matiere: it.matiere, score: it.score, type: 'J0', date: window.toYYYYMMDD(stD), status: 'pending', isDouble: true });
                }

                ints.forEach(function(d) {
                    if (d >= blocDepuis) return; // revu en un bloc, plus bas
                    var nD = new Date(pDate); nD.setDate(nD.getDate() + d);
                    var typ = d > c.maxJLimit ? 'Loop' : 'J'+d;
                    pousser({ id: pId+"_"+typ+d+"_"+contexte.now()+"_"+num+"_"+index+"_"+pIdx, itemId: pId, baseItemId: it.id, titre: pTitre, matiere: it.matiere, score: it.score, type: typ, date: window.toYYYYMMDD(nD), status: 'pending', isDouble: false });
                    
                    if(isPed && pIdx === 0) {
                        var nDPed = new Date(stD); nDPed.setDate(nDPed.getDate() + d);
                        pousser({ id: it.id+"_"+typ+d+"_bis_"+contexte.now()+"_"+num+"_"+index, itemId: it.id, baseItemId: it.id, titre: it.titre, matiere: it.matiere, score: it.score, type: typ, date: window.toYYYYMMDD(nDPed), status: 'pending', isDouble: true });
                    }
                });
            });
            if (blocDepuis !== Infinity) {
                var derniere = new Date(stD); derniere.setDate(derniere.getDate() + (parts.length - 1) * pas);
                ints.forEach(function(d) {
                    if (d < blocDepuis) return;
                    var nD = new Date(derniere); nD.setDate(nD.getDate() + d);
                    var typ = d > c.maxJLimit ? 'Loop' : 'J'+d;
                    pousser({ id: it.id+"_"+typ+d+"_bloc_"+contexte.now()+"_"+num+"_"+index, itemId: it.id, baseItemId: it.id, titre: it.titre, matiere: it.matiere, score: it.score, type: typ, date: window.toYYYYMMDD(nD), status: 'pending', isDouble: false, bloc: true });
                });
            }
            plT++;
        });
    };
    lot(c.selectedSpecs, c.configStartDate, 0);
    var debutLissage = c.configStartDate;
    if (c.deuxiemeLot && (c.selectedSpecs2 || []).length) {
        var d2 = /^\d{4}-\d{2}-\d{2}$/.test(c.configStartDate2 || '') ? c.configStartDate2 : c.configStartDate;
        lot(c.selectedSpecs2, d2, 1);
        if (d2 < debutLissage) debutLissage = d2;
    }
    if (cap || capJ0 || capRev) nT = window.actions.fixJ0Collisions(window.lisserTaches(nT, [{ jusquau: '', limite: cap, limiteJ0: capJ0, limiteRev: capRev }], 'new', debutLissage, pas));
    return { tasks: nT, enRetard: enRetard };
}
window.construirePlanning = construirePlanning;

window.actions.triggerAutoPlan = function() {
    var c = window.state;
    if(c.selectedSpecs.length === 0) return alert("Sélectionnez au moins une matière.");
    if(c.deuxiemeLot && !(c.selectedSpecs2 || []).length) return alert("Choisis les matières du deuxième planning, ou décoche-le.");
    if(!confirm(c.appendMode ? "Ajouter au planning ?" : "Écraser le planning ?")) return;
    var resultat = construirePlanning(c, { items: window.ednsItems, now: Date.now });
    var nT = resultat.tasks, enRetard = resultat.enRetard;
    if (enRetard.length) {
        var exemples = enRetard.slice(0, 3).map(function(it) { return '#' + it.id + ' ' + it.titre; }).join(', ');
        alert(enRetard.length + ' item' + (enRetard.length > 1 ? 's' : '') + ' des partiels commence' + (enRetard.length > 1 ? 'nt' : '') + ' trop tard pour être au J demandé le jour du partiel (' + exemples + (enRetard.length > 3 ? '…' : '') + '). Augmente la charge par jour, avance la date de départ ou baisse le J cible du partiel.');
    }
    window.state.showAutoPlanModal = false;
    window.state.activeTab = 'calendrier';
    window.planningAction('Auto-planification');
    window.syncWithServer('save_tasks', { tasks: nT }, function() { window.renderApp(); });
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const BUILTIN_AUTOPLAN_PRESETS = window.BUILTIN_AUTOPLAN_PRESETS;
export const builtinPresetConfig = window.builtinPresetConfig;
export const loadAutoPlanPresetsLocal = window.loadAutoPlanPresetsLocal;
export const saveAutoPlanPresetsLocal = window.saveAutoPlanPresetsLocal;
export const ordreCles = window.ordreCles;
export const ordreVisible = window.ordreVisible;
export const appliquerReglagesIA = window.appliquerReglagesIA;
